import {
  LoginRequest,
  LoginResponse,
} from "services/management-backend/client";
import { ToastConfig } from "core/widgets/toastConfig.widget";
import { AxiosError } from "axios";
import { AuthActionTypes, useStateDispatcher } from "state";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { useClientContext } from "clients";
import { toast } from "react-toastify";
import paths from "paths";

const INVALID_USERNAME_OR_PASSWORD_ERROR = "Email or password is incorrect";

const useLogin = () => {
  const dispatcher = useStateDispatcher();
  const clients = useClientContext();

  const navigate = useNavigate();

  return useMutation({
    mutationFn: (req: LoginRequest) => clients.management.login(req),
    onSuccess: (tokens: LoginResponse) => {
      const token = `Bearer ${tokens.token}`;
      dispatcher({
        type: AuthActionTypes.SET_TOKEN,
        tokens: { ...tokens, token },
      });
    },
    onError: (err: AxiosError, { email }: LoginRequest) => {
      if (err?.response?.status === 401) {
        toast.error(INVALID_USERNAME_OR_PASSWORD_ERROR, ToastConfig);
      }

      if (err?.response?.status === 412) {
        navigate(`/${paths.open.UPDATE}?email=${email.trim()}`);
      }
    },
  });
};

export default useLogin;
